import { State } from '@/store/store'

export class PatientState {
  public list: PatientList
  public patient: IPatient
  public typeList: PatientTypeList
  public typeById: IPatientType

  constructor() {
    this.list = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.patient = {
      _id: '',
      idCard: '',
      userId: '',
      // centerId: '',
      patientTypeId: '',
      prefix: '',
      firstname: '',
      lastname: '',
      phone: '',
      sosPhone: '',
      drugAllergy: '',
      disease: '',
      hospital: '',
      birthdate: '',
      status: '',
      map: {
        lat: 0,
        lon: 0,
      },
      address: {
        address: '',
      },
      metadata: {},
    }
    this.typeList = {
      column: [],
      itemCount: 0,
      page: 1,
      pageCount: 1,
      result: [],
      defaultFilter: {},
    }
    this.typeById = {
      _id: '',
      minExp: 0,
      name: '',
    }
  }
}
export interface PatientList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id: string,
    name?: string,
    idCard: string,
    userId: string,
    // centerId: string,
    profile?: string,
    patientTypeId: string,
    prefix: string,
    firstname: string,
    lastname: string,
    phone?: string,
    sosPhone?: string,
    drugAllergy: string,
    disease: string,
    hospital: string,
    birthdate?: string,
    status: string,
    map: {
      lat: number,
      lon: number,
    },
    address: {
      address: string,
      country?: string,
      district?: string,
      elevation?: number,
      geocode?: string,
      postcode?: string,
      province?: string,
      road?: string,
      road_lat?: number,
      road_lon?: number,
      subdistrict?: string,
    },
    metadata?: any,
    createdAt?: number,
    updatedAt?: number,
  }>
}
export interface IPatient {
  _id: string,
  prefix?: string,
  name?: string,
  idCard: string,
  userId: string,
  // centerId: string,
  profile?: string,
  patientTypeId: string,
  firstname: string,
  lastname: string,
  phone: string,
  sosPhone: string,
  drugAllergy: string,
  disease: string,
  hospital: string,
  birthdate: string,
  status: string,
  map: {
    lat: number,
    lon: number,
  },
  address: {
    address: string,
    country?: string,
    district?: string,
    elevation?: number,
    geocode?: string,
    postcode?: string,
    province?: string,
    road?: string,
    road_lat?: number,
    road_lon?: number,
    subdistrict?: string,
  },
  metadata?: any,
  createdAt?: number,
  updatedAt?: number,
}

export interface PatientTypeList {
  column: Array<{
    text: string
    value: string
    type?: string
    options?: {
      orderable?: boolean
      lengthLimit?: number
      filter?: boolean
      operation: string[],
    },
  }>
  defaultFilter: object
  itemCount: number
  page: number
  pageCount: number
  result: Array<{
    _id: string,
    minExp: number,
    name: string,
  }>
}

export interface IPatientType {
  _id: string,
  minExp: number,
  name: string,
}

export default PatientState
